import { createFileRoute } from '@tanstack/react-router';

import {
    FLEXIBLE_CALCULATION_APP_TABS_SLOT,
    FlexibleCalculationAppTabLayout,
} from '@/areas/flexible-calculations/FlexibleCalculationTemplates/FlexibleCalculationTemplatesTabs';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { AppTabRoute } from '@/shared/routing/appTabs';

export const Route = createFileRoute('/_authenticated/next/templates/flexible-calculation/apps/$appId/$widgetId')({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'none',
    } satisfies PageStaticData,
    component: () => (
        <AppTabRoute slotId={FLEXIBLE_CALCULATION_APP_TABS_SLOT} layout={FlexibleCalculationAppTabLayout} />
    ),
});
